const LocationOutlineIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 13.4301C13.7231 13.4301 15.12 12.0333 15.12 10.3101C15.12 8.587 13.7231 7.19012 12 7.19012C10.2769 7.19012 8.88 8.587 8.88 10.3101C8.88 12.0333 10.2769 13.4301 12 13.4301Z" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M3.62001 8.49012C5.59001 -0.169876 18.42 -0.159875 20.38 8.50012C21.53 13.5801 18.37 17.8801 15.6 20.5401C13.59 22.4801 10.41 22.4801 8.39001 20.5401C5.63001 17.8801 2.47001 13.5701 3.62001 8.49012Z" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
  );
};

export default LocationOutlineIcon;
